// Naziv banke po vbdi dolazi sa servera (window.BANKS_BY_VBDI u index.html),
// da bi registar banaka ostao jedini izvor istine.

// Sandbox test data (testIbans, psuData, getRandomIban) lives in demo.js.
// IBAN validation and bank naming live in iban.js. Both load before this file.

// Page chrome. One handler rather than the two that used to run here plus a
// third in $(document).ready - between them the year was set twice, and an
// unguarded getElementById would take the rest of the block down with it if the
// element ever moved.
// Every jQuery call carries the session's CSRF token. The form post sends
// it as a field as well, from form.hidden_tag(); the header covers the calls
// that send JSON or FormData instead.
$.ajaxSetup({ headers: { "X-CSRFToken": window.CSRF_TOKEN } });

document.addEventListener("DOMContentLoaded", () => {
  // In a sandbox deployment the first field starts pre-filled with a test
  // IBAN; elsewhere getRandomIban() returns "" and it starts empty.
  const ibanInput = document.querySelector(".iban-input");
  if (ibanInput) {
    ibanInput.value = getRandomIban();
  }

  const footerLink = document.querySelector("#footer-version");
  if (footerLink && typeof APP_VERSION !== "undefined") {
    footerLink.innerHTML += ` v.${APP_VERSION}`;
  }

  const year = document.getElementById("current-year");
  if (year) {
    year.textContent = new Date().getFullYear();
  }
});

// IBAN parsing and validation live in iban.js, loaded before this file.
// bankNameForIban, ibanProblem, validateIban and normaliseIban come from there.

function updateBankHint(input) {
  var hint = $(input).closest("#iban-form > div").find(".iban-bank");
  if (!hint.length) return;
  var name = bankNameForIban($(input).val(), window.BANKS_BY_VBDI);
  hint.text(name || "").toggleClass("is-visible", Boolean(name));
}

function refreshBankHints() {
  $(".iban-input").each(function () {
    updateBankHint(this);
  });
}

$(document).on("input change", ".iban-input", function () {
  updateBankHint(this);
});

// The step indicator (activateStep, deactivateStep, completeStep) and the
// mobile scrolling helpers live in stepper.js.

// WebSocketClient lives in bank-status.js; the bank cards, bankState and
// bankDetail live in bank-cards.js. Both load before this file.

$(document).ready(function () {
  refreshBankHints();

  // Initially disable the next2 button
  $("#next2").prop("disabled", true);

  //omogućava submit button samo ako je checkbox za pristanak na uvjete korištenja označen
  $("#consent-field").change(function () {
    if (this.checked) {
      $("#next2").prop("disabled", false);
    } else {
      $("#next2").prop("disabled", true);
    }
  });

  //Make the entire consent container clickable
  $("#consent-container").on("click", function (e) {
    // This ensures we don't interfere with clicks directly on the checkbox or label
    if (e.target === this) {
      const checkbox = $("#consent-field");
      // Toggle the checkbox's 'checked' state
      checkbox.prop("checked", !checkbox.prop("checked"));
      // Manually trigger the 'change' event to update the 'Potvrdi' button
      checkbox.trigger("change");
    }
  });

  // Function to update the background color of the remove button
  function updateRemoveButtonBackground(inputElement) {
    var backgroundColor = $(inputElement).css("background-color");
    $(inputElement)
      .closest(".hero")
      .find(".remove-button")
      .css("background-color", backgroundColor);
  }

  // An invalid field is shown with the danger tokens rather than the hex
  // colours that used to be written in here, and the remove button beside it
  // follows, so the row reads as one thing.
  function markInvalid(input, invalid) {
    const field = $(input);
    field.toggleClass("border-danger bg-danger-soft", invalid);
    field.toggleClass("border-border-strong bg-surface", !invalid);
    field.closest(".hero").find(".remove-button")
      .toggleClass("bg-danger-soft", invalid);
  }

  // scrollToStepper and scrollToPageTop come from stepper.js.
  // On load, start at the top of the page on mobile.
  scrollToPageTop();

  //korak 1 - naprijed IBAN/banka
  $("#next1").click(function (e) {
    // Collect the first problem, so the customer is told what is actually
    // wrong rather than being sent to re-read every field.
    let firstProblem = null;
    $("#iban-form input").each(function () {
      const problem = ibanProblem($(this).val());
      if (!problem) {
        markInvalid(this, false);
        return;
      }
      firstProblem = firstProblem || problem;
      markInvalid(this, true);
    });

    const isValid = firstProblem === null;
    if (!isValid) {
      e.preventDefault(); // Prevent the form from proceeding to the next step
      $("#step1-error-message").text(firstProblem).show();
    }
    if (isValid) {
      $("#step1-error-message").text("").hide(); // Clear the error message
      $("#step1").hide();
      completeStep(1);
      deactivateStep(3);
      activateStep(2);
      $("#step2").show();
      scrollToStepper();
    }
  });

  //korak 2 - nazad
  $("#back2").click(function (e) {
    e.preventDefault();
    $("#consent-field").prop("checked", false);
    $("#next2").prop("disabled", true);
    $("#step2").hide();
    deactivateStep(2);
    deactivateStep(3);
    activateStep(1);
    $("#step1").show();
    resetStepNumber(1);
    $("#step1").show();
    scrollToPageTop();
  });

  $("#next2").click(function (e) {
    e.preventDefault();
    $("#consent-field").prop("checked", false);
    var formData = $("#main-form").serialize();
    $.ajax({
      type: $("#main-form").attr("method"),
      url: $("#main-form").attr("action"),
      data: formData,
      success: function (response) {
        $("#step2").hide();
        completeStep(2);
        activateStep(3);
        $("#step3").show();
        createBankElements(response);
        retrieveData();
        scrollToStepper();
      },
      error: function (jqXHR, textStatus) {
        // Silently doing nothing here meant a failed submit looked like a
        // dead button: no message, no log, nothing to report to support.
        console.error("Submitting the IBAN form failed:", textStatus, jqXHR.status);
        $("#step2-error-message")
          .text("Slanje zahtjeva nije uspjelo. Pokušajte ponovno.")
          .show();
        $("#next2").prop("disabled", false);
      },
    });
  });

  //dodavanje polja za unos IBANa
  var numberOfIbans = 5;
  var ibanCounter = 1;
  $("#add-button").click(function (event) {
    event.preventDefault();
    if ($("#iban-form").children().length < numberOfIbans) {
      var newChild = $(
            // Matches the first field, which the template renders: same
            // spacing, same border, no shadow. The row sits inside the card,
            // and a shadow within a card reads as a second card.
            `<div class="hero pb-2">
                <div class="search-box w-full">
                    <div class="flex items-center w-full bg-surface border border-border-strong rounded-field focus-within:border-primary transition-colors">
                        <input
                            type="text"
                            placeholder="Ovdje unesite IBAN..."
                            value="${getRandomIban()}"
                            aria-label="IBAN"
                            class="iban-input w-full px-3.5 py-2.5 text-base font-medium bg-transparent outline-none rounded-field"
                        />
                        <button
                            type="button"
                            aria-label="Ukloni račun"
                            class="remove-button px-3.5 py-2.5 text-text-subtle hover:text-danger bg-transparent transition-colors rounded-field">
                            <i class="fa-solid fa-xmark"></i>
                        </button>
                    </div>
                    <p class="iban-bank"></p>
                </div>
            </div>`
      );
      newChild.find("input").attr("id", "ibans-" + ibanCounter + "-iban");
      newChild.find("input").attr("name", "ibans-" + ibanCounter + "-iban");
      $("#iban-form").append(newChild);
      refreshBankHints();
      ibanCounter++;
      // Hide add button if maximum number of IBANs is reached
      if ($("#iban-form").children().length >= numberOfIbans) {
        $("#add-button").hide();
      }
    }
    updateRemoveButtons();
  });

  // Update remove buttons visibility
  function updateRemoveButtons() {
    const removeButtons = $("#iban-form").find(".remove-button");
    if (removeButtons.length === 0) {
      removeButtons.addClass("hidden");
    } else {
      removeButtons.removeClass("hidden");
    }
  }

  // Change background color of input and update remove button background color
  $("#iban-form").on("input", ".iban-input", function () {
    var inputElement = this;
    setTimeout(function () {
      updateRemoveButtonBackground(inputElement);
    }, 0);
  });

  // Remove IBAN input field
  $("#iban-form").on("click", ".remove-button", function (event) {
    event.preventDefault();
    if ($("#iban-form").children().length > 1) {
      $(this).closest(".hero").remove();
    }
    // Show add button if the number of IBANs is less than the maximum
    if ($("#iban-form").children().length < numberOfIbans) {
      $("#add-button").show();
    }
    updateRemoveButtons();
  });

  // Colour the field only once there is enough typed to judge it. Flagging a
  // half-typed IBAN as wrong is noise, and with real validation now running it
  // would mean the field is red for every keystroke but the last.
  $("#iban-form").on("input", "input", function () {
    const iban = normaliseIban($(this).val());
    const format = ibanFormat[iban.slice(0, 2)];
    const readyToJudge = format && iban.length >= format.length;
    markInvalid(this, readyToJudge && !validateIban(iban));
  });

  // Clear error message when user starts typing in any IBAN field
  $(document).on("input", ".iban-input", function () {
    // Assuming the error message is in an element with the class 'error-message'
    $("#step1-error-message").text("").hide();
  });
  // The journey itself - pre-auth, consent, resources and the email form
  // - lives in journey.js. retrieveData() comes from there.
  
  updateRemoveButtons();
});
